// extracted by mini-css-extract-plugin
export default {"success":"Review_success__+bNKD","image":"Review_image__h3R5w","btn":"Review_btn__Ik7ap","message":"Review_message__5Crry","link":"Review_link__Vydaz"};